import { InvestorEntity } from '../services/investor-service';
import { RequestChangeDialog } from './RequestChangeDialog';

interface EntityEditModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  entity: InvestorEntity | null;
}

export function EntityEditModal({
  open,
  onOpenChange,
  entity,
}: EntityEditModalProps) {
  return (
    <RequestChangeDialog
      isOpen={open}
      onClose={() => onOpenChange(false)}
      entity={
        entity
          ? {
              id: entity.id,
              name: entity.name,
              address: entity.address,
              bankDetails: entity.bankDetails,
            }
          : undefined
      }
    />
  );
}
